export default function CsharpConstructors() {
  return (
    <h2>Csharp Constructors</h2>
  );
}
